package br.com.vvrefeicoes.portal.data.repository

import br.com.vvrefeicoes.portal.core.util.PeriodMode
import br.com.vvrefeicoes.portal.core.util.PeriodSelection
import io.ktor.http.encodeURLParameter

/** Monta a query comum dos endpoints do Painel (período + filtros). Sem período quando o modo é Total. */
internal fun panelQuery(
    selection: PeriodSelection,
    unitId: String?,
    manager: String?,
    director: String?,
): String =
    buildList {
        when (selection.mode) {
            PeriodMode.MONTH -> add("period=mensal&year=${selection.month.year}&month=${selection.month.month}")
            PeriodMode.YEAR -> add("period=anual&year=${selection.year}")
            PeriodMode.TOTAL -> add("period=total")
            PeriodMode.CUSTOM -> add("period=personalizado&start=${selection.start.id}&end=${selection.end.id}")
        }
        unitId?.takeIf { it.isNotBlank() }?.let { add("unitId=" + it.encodeURLParameter()) }
        manager?.takeIf { it.isNotBlank() }?.let { add("manager=" + it.encodeURLParameter()) }
        director?.takeIf { it.isNotBlank() }?.let { add("director=" + it.encodeURLParameter()) }
    }.joinToString("&")
